module.exports = "<p>\n  event-sponsors works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-sponsors/event-sponsors.component.html
// module id = ./src/app/routes/event/event-sponsors/event-sponsors.component.html
// module chunks = 9